import { Outlet, useLocation } from "react-router-dom";
import { LogoutIcon } from "../../components/tailwind";
import { logout } from "../../utils";
import { CssBaseline, styled, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setDataTheme } from "../../context/themeSlice";
import Sidebar from "./Sidebar";
import { drawerWidth, SET_MENU } from "../../context/customizationSlice/types";
import { isMobile } from "react-device-detect";
import { setCustomization } from "../../context/customizationSlice";
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import NotificationBadge from "../../components/notificationBadge";

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' && prop !== 'comprimentoMenuLateral' && prop !== 'lojaConfigurada' })(({ theme, open, comprimentoMenuLateral }) => ({
    ...theme.typography.mainContent,
    ...(!open && {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        [theme.breakpoints.up('md')]: {
            marginLeft: comprimentoMenuLateral > 0 ? (isMobile ? null : 50) : 0,
            width: '95%'
        },
        [theme.breakpoints.down('md')]: {
            marginLeft: isMobile ? null : '20px',
            width: '100%',
            padding: '16px',
            paddingRight: 0,
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: comprimentoMenuLateral > 0 ? (isMobile ? null : 50) : 0,
            width: '100%',
            padding: '16px',
            paddingRight: 0,
            marginRight: '50px'
        }
    }),
    ...(open && {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        marginLeft: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        width: `calc(100% - ${comprimentoMenuLateral}px)`,
        marginLeft: isMobile ? null : comprimentoMenuLateral - 40,
        [theme.breakpoints.down('md')]: {
            marginLeft: isMobile ? null : '20px'
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: '10px'
        }
    })
}));

const MainLayout = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const leftDrawerOpened = useSelector((state) => state.customization.opened);
    const [comprimentoMenuLateral, setComprimentoMenuLateral] = useState(0);
    const [darkMode, setDarkMode] = useState(() => {
        return localStorage.getItem("theme") === "dark";
    });

    useEffect(() => {
        if (darkMode) {
            document.documentElement.classList.add("dark");
            localStorage.setItem("theme", "dark");
            dispatch(setDataTheme({ theme: "dark" }));
        } else {
            document.documentElement.classList.remove("dark");
            localStorage.setItem("theme", "light");
            dispatch(setDataTheme({ theme: "light" }));
        }
    }, [darkMode]);

    useEffect(() => {
        setComprimentoMenuLateral(!location.pathname.includes('lojas') && !isMobile ? drawerWidth : 0);
    }, [location]);

    const toggleTheme = () => setDarkMode(!darkMode);

    const handleLeftDrawerToggle = () => {
        dispatch(setCustomization({ type: SET_MENU, opened: !leftDrawerOpened }));
    };

    return <div className="w-[100%] bg-gray-100 dark:bg-gray-900">
        <CssBaseline />

        <Sidebar drawerOpen={leftDrawerOpened} drawerToggle={handleLeftDrawerToggle} />

        <div className="w-full h-5 flex flex-row justify-end">
            <div className="mr-20 mt-5 text-black dark:text-white cursor-pointer">
                <NotificationBadge count={10} />
            </div>

            <button
                onClick={toggleTheme}
                className="absolute top-4 right-16 p-2 bg-gray-200 dark:bg-gray-700 rounded-full text-gray-900 dark:text-white"
            >
                {darkMode ? "☀️" : "🌙"}
            </button>
            <LogoutIcon className="cursor-pointer text-black dark:text-white mr-5 mt-6" onClick={() => logout()} />
        </div>

        <Main open={leftDrawerOpened} comprimentoMenuLateral={comprimentoMenuLateral} className="w-full h-full p-20 pr-0 bg-gray-100 dark:bg-gray-900 pl-30">
            <Outlet />
        </Main>
    </div>
}

export default MainLayout;